// importing ws calls for entity Registro
import {
  retrieveEduRecsWS,
  createEduRecWS,
  retrieveEduRecWS,
  openEduRecWS,
  closeEduRecWS,
  deleteEduRecWS,
  updateEduRecAnnotationWS,
  updateRegistryAbsencesWS,
  retrieveProgram,
} from 'util/Ajax/registro.jsx';

// importing ws calls for entity Registro Occurrences
import {
  retrieveRegistryOccurrencesWS,
  insertRegistryOccurrencesWS,
  removeRegistryOccurrencesWS,
  updateRegistryOccurrencesWS,
} from 'util/Ajax/occorrenze.jsx';

// importing ws calls for entity Registro Trasversale
import {
  retrieveTrasRecsWS,
  createTrasversalRecWS,
  retrieveTrasOccurrencesWS,
  openTrasversalRecWS,
  closeTrasversalRecWS,
  deleteTrasversalRecWS,
  updateTrasversalNotesWS,
  insertTrasversalActivitiesWS,
  removeTrasversalActivitiesWS,
  updateTrasversalActivitiesWS,
  retrieveTrasFormeDidWS,
} from 'util/Ajax/trasversal.jsx';

// importing ws calls for entity User
import { retrieveUser } from 'util/Ajax/user.jsx';

// importing action types
import {
  EDURECS,
  EDUREC,
  OCCURRENCES,
  TRASVERSAL,
  TRAS_OCCURRENCES,
  USER,
} from 'actions/actionTypes.js';

import { getActualYear } from 'util/AcademicYears.jsx';

// ACTIONS FOR REGISTRI
export function loadTrasversal() {
  return {
    type: TRASVERSAL.LOAD,
    payload: {},
  };
}

export function fetchEduRecsOngoing(acYear) {
  return {
    type: EDURECS.FETCH,
    payload: acYear,
  };
}

export function fetchEduRecsCompleted(edurecords, error = false) {
  console.log('cosa ho recuperato dai servizi:', edurecords);
  return {
    type: EDURECS.FETCH_COMPLETED,
    payload: edurecords,
    error,
  };
}

// ACTIONS FOR REGISTRI CRITICI
export function fetchCriticalEduRecsOngoing(acYear) {
  return {
    type: EDURECS.FETCH_CRIT,
    payload: acYear,
  };
}

export function fetchCriticalEduRecsCompleted(edurecords, error = false) {
  return {
    type: EDURECS.FETCH_CRIT_COMPLETED,
    payload: edurecords,
    error,
  };
}

export function fetchCriticalEduRecs() {
  const year = getActualYear();
  return (dispatch) => {
    dispatch(fetchCriticalEduRecsOngoing(year));
    return Promise.all([
      retrieveEduRecsWS(year - 1),
      retrieveEduRecsWS(year - 2),
    ])
      .then(responses => {
        console.log(responses[0].concat(responses[1]));
        dispatch(fetchCriticalEduRecsCompleted(responses[0].concat(responses[1])));
      });
  };
}

// ACTIONS FOR REGISTRI TRASVERSALI
export function fetchTrasRecsCompleted(trasrecords, error = false) {
  return {
    type: TRASVERSAL.FETCH_COMPLETED,
    payload: trasrecords,
    error,
  };
}

// GLOBAL ACTION FOR REGISTRILIST APP
export function fetchEduRecs(acYear) {
  const year = acYear.split('-')[1];
  console.log('che anno ho passato:', year);
  return (dispatch) => {
    dispatch(fetchEduRecsOngoing(acYear));
    return retrieveEduRecsWS(year)
      .then(response => {
        dispatch(fetchEduRecsCompleted(response));
        return retrieveTrasRecsWS(year)
          .then(response2 =>
                dispatch(fetchTrasRecsCompleted(response2))
                , eventerror => {
                  dispatch(fetchTrasRecsCompleted({ error: eventerror }, true));
                  const error = new Error('Impossible to fetch Trasversal Records' +
                                          `Cause: ${eventerror.message || eventerror}`);
                  error.error = eventerror;
                  throw error;
                });
      }, eventerror => {
        dispatch(fetchEduRecsCompleted({ error: eventerror }, true));
        const error = new Error('Impossible to fetch Educational Records' +
                                `Cause: ${eventerror.message || eventerror}`);
        error.error = eventerror;
        throw error;
      });
  };
}

// ACTIONS FOR ACADEMIC YEAR SELECTION
export function selectedACYear(selectedOption) {
  return {
    type: EDURECS.SELECT_ACYEAR,
    payload: selectedOption,
  };
}

export function selectACYear(selectedOption) {
  const year = selectedOption.split('-')[1];
  return (dispatch) => {
    dispatch(selectedACYear(selectedOption));
    dispatch(fetchEduRecsOngoing(year));
    return retrieveEduRecsWS(year)
      .then(response => {
        dispatch(fetchEduRecsCompleted(response));
        return retrieveTrasRecsWS(year)
            .then(response2 =>
                  dispatch(fetchTrasRecsCompleted(response2))
                  , eventerror => {
                    dispatch(fetchTrasRecsCompleted({ error: eventerror }, true));
                    const error = new Error('Impossible to fetch Educational Records' +
                                            `Cause: ${eventerror.message || eventerror}`);
                    error.error = eventerror;
                    throw error;
                  });
      }, eventerror => {
        dispatch(fetchEduRecsCompleted({ error: eventerror }, true));
        const error = new Error('Impossible to fetch Educational Records' +
                                `Cause: ${eventerror.message || eventerror}`);
        error.error = eventerror;
        throw error;
      });
  };
}

// ACTIONS FOR REGISTRO
export function fetchEduRecOngoing(registryId) {
  return {
    type: EDUREC.FETCH,
    payload: registryId,
  };
}

export function fetchEduRecCompleted(registry, error = false) {
  console.log('fetchato registro:', registry);
  return {
    type: EDUREC.FETCH_COMPLETED,
    payload: registry,
    error,
  };
}

export function fetchProgramOngoing(codEdizione) {
  return {
    type: EDUREC.FETCH_PROGRAM,
    payload: codEdizione,
  };
}

export function fetchProgramCompleted(program, error = false) {
  if (error) {
    return {
      type: EDUREC.FETCH_PROGRAM_COMPLETED,
      payload: {},
      error,
    };
  }
  return {
    type: EDUREC.FETCH_PROGRAM_COMPLETED,
    payload: program,
    error,
  };
}

export function creatingEduRec(idCopertura) {
  return {
    type: EDUREC.CREATE,
    payload: idCopertura,
  };
}

export function creatingEduRecCompleted(registry, error = false) {
  console.log('registro creato: ', registry);
  return {
    type: EDUREC.CREATE_COMPLETED,
    payload: registry,
    error,
  };
}

export function createEduRec(idCopertura) {
  return (dispatch) => {
    dispatch(creatingEduRec(idCopertura));
    return createEduRecWS(idCopertura)
      .then(response =>
            dispatch(creatingEduRecCompleted(response))
            , eventerror => {
              dispatch(creatingEduRecCompleted({ error: eventerror }, true));
              const error = new Error(`Unable to update Covering no. : ${idCopertura}` +
                                      `Cause: ${eventerror.message || eventerror}`);
              error.error = eventerror;
              throw error;
            });
  };
}

export function closingEduRec(registryId) {
  return {
    type: EDUREC.CLOSE,
    payload: registryId,
  };
}

export function closedEduRec(registry) {
  return {
    type: EDUREC.CLOSE_COMPLETED,
    payload: registry,
  };
}

export function setEduRecClosed(registryId) {
  return (dispatch) => {
    dispatch(closingEduRec(registryId));
    return closeEduRecWS(registryId)
      .then(response =>
            dispatch(closedEduRec(response)));
  };
}

export function openingEduRec(registryId) {
  return {
    type: EDUREC.OPEN,
    payload: registryId,
  };
}

export function openedEduRec(registry) {
  return {
    type: EDUREC.OPEN_COMPLETED,
    payload: registry,
  };
}

export function setEduRecOpened(registryId) {
  return (dispatch) => {
    dispatch(openingEduRec(registryId));
    return openEduRecWS(registryId)
      .then(response =>
            dispatch(openedEduRec(response)));
  };
}

export function deletingEduRec(registryId) {
  return {
    type: EDUREC.DELETE,
    payload: registryId,
  };
}

export function deletedEduRec(registryId) {
  return {
    type: EDUREC.DELETE_COMPLETED,
    payload: registryId,
  };
}

export function setEduRecDeleted(registryId) {
  return (dispatch) => {
    dispatch(deletingEduRec(registryId));
    return deleteEduRecWS(registryId)
      .then(
        dispatch(deletedEduRec(registryId))
      );
  };
}

export function updatingRegistryAbsences(registryId) {
  return {
    type: EDUREC.UPDATING_ABSENCES,
    payload: registryId,
  };
}

export function updateRegistryAbsencesCompleted(absences, error = false) {
  return {
    type: EDUREC.UPDATING_ABSENCES_COMPLETED,
    payload: absences,
    error,
  };
}

export function updateRegistryAbsences(registryId, absences) {
  return (dispatch) => {
    dispatch(updatingRegistryAbsences(registryId));
    return updateRegistryAbsencesWS(registryId, absences)
      .then(response =>
            dispatch(updateRegistryAbsencesCompleted(response))
            , eventerror => {
              dispatch(updateRegistryAbsencesCompleted({ error: eventerror }, true));
              const error = new Error('Unable to update Absences' +
                                      `for Educational Record no. : ${registryId}` +
                                      `Cause: ${eventerror.message || eventerror}`);
              error.error = eventerror;
            });
  };
}

export function updatingRegistryNotes(registryId) {
  return {
    type: EDUREC.UPDATING_NOTES,
    payload: registryId,
  };
}

export function updateRegistryNotesCompleted(registry, error = false) {
  return {
    type: EDUREC.UPDATING_NOTES_COMPLETED,
    payload: registry,
    error,
  };
}

export function updateRegistryNotes(registryId, notes) {
  return (dispatch) => {
    dispatch(updatingRegistryNotes(registryId));
    return updateEduRecAnnotationWS(registryId, notes)
      .then(response =>
            dispatch(updateRegistryNotesCompleted(response))
            , eventerror => {
              dispatch(updateRegistryNotesCompleted({ error: eventerror }, true));
              const error = new Error('Unable to update Notes' +
                                      `for Educational Record no. : ${registryId}` +
                                      `Cause: ${eventerror.message || eventerror}`);
              error.error = eventerror;
            });
  };
}

// ACTIONS FOR REGISTRO OCCORRENZE
export function fetchOccurrencesOngoing(registryId) {
  return {
    type: OCCURRENCES.FETCH,
    payload: registryId,
  };
}

export function fetchOccurrencesCompleted(occurrences, error = false) {
  if (error) {
    return {
      type: OCCURRENCES.FETCH_COMPLETED,
      payload: [],
      error,
    };
  }
  return {
    type: OCCURRENCES.FETCH_COMPLETED,
    payload: occurrences,
    error,
  };
}

export function insertingRegistryOccurences(registryId) {
  return {
    type: OCCURRENCES.CREATE,
    payload: registryId,
  };
}

export function insertRegistryOccurrencesCompleted(occurrences, error = false) {
  return {
    type: OCCURRENCES.CREATE_COMPLETED,
    payload: occurrences,
    error,
  };
}

export function removingRegistryOccurrences(registryId) {
  return {
    type: OCCURRENCES.DELETE,
    payload: registryId,
  };
}

export function removeRegistryOccurrencesCompleted(occurrences, error = false) {
  return {
    type: OCCURRENCES.DELETE_COMPLETED,
    payload: occurrences,
    error,
  };
}

export function updatingRegistryOccurences(registryId) {
  return {
    type: OCCURRENCES.UPDATE,
    payload: registryId,
  };
}

export function updateRegistryOccurrencesCompleted(occurrences, error = false) {
  return {
    type: OCCURRENCES.UPDATE_COMPLETED,
    payload: occurrences,
    error,
  };
}

export function insertRegistryOccurrencesRemote(registryId, occurrences) {
  return (dispatch) => {
    dispatch(insertingRegistryOccurences(registryId));
    return insertRegistryOccurrencesWS(registryId, occurrences)
      .then(response =>
            dispatch(insertRegistryOccurrencesCompleted(response))
            , eventerror => {
              dispatch(insertRegistryOccurrencesCompleted({ error: eventerror }, true));
              return Promise.reject(eventerror);
            });
  };
}

export function removeRegistryOccurrences(registryId, occurrences) {
  return (dispatch) => {
    dispatch(removingRegistryOccurrences(registryId));
    return removeRegistryOccurrencesWS(registryId, occurrences)
      .then(response =>
            dispatch(removeRegistryOccurrencesCompleted(response))
            , eventerror => Promise.reject(eventerror)
            );
  };
}

export function updateRegistryOccurrences(registryId, occurrences) {
  return (dispatch) => {
    dispatch(updatingRegistryOccurences(registryId));
    return updateRegistryOccurrencesWS(registryId, occurrences)
      .then(response =>
            dispatch(updateRegistryOccurrencesCompleted(response))
            , eventerror => {
              dispatch(updateRegistryOccurrencesCompleted({ error: eventerror }, true));
              const error = new Error(`Unable to update Educational Record no. : ${registryId}` +
                                      `Cause: ${eventerror.message || eventerror}`);
              error.error = eventerror;
            });
  };
}


// GLOBAL ACTIONS FOR EDIT REGISTRO APP
export function fetchEduRec(registryId) {
  console.log('fetching registro id:', registryId);
  return (dispatch) => {
    dispatch(fetchEduRecOngoing(registryId));
    dispatch(fetchOccurrencesOngoing(registryId));
    return retrieveEduRecWS(registryId)
      .then(response => {
        dispatch(fetchEduRecCompleted(response));
        dispatch(fetchProgramOngoing);
        // lancio le chiamate ai ws per recuperare i dati delle attivita e del programma didattico
        return Promise.all([
          retrieveRegistryOccurrencesWS(registryId)
            .then(response2 => dispatch(fetchOccurrencesCompleted(response2)),
                  eventerror => {
                    dispatch(fetchOccurrencesCompleted({ error: eventerror }, true));
                    const error = new Error('Unable to fetch Occurrences for registry ' +
                                            `: ${registryId}` +
                                            `Cause: ${eventerror.message || eventerror}`);
                    error.error = eventerror;
                  }),
          retrieveProgram(response.annoAccademico, response.codCDL, response.codEdizioneSmall)
            .then(response2 => dispatch(fetchProgramCompleted(response2)),
                  eventerror => {
                    dispatch(fetchProgramCompleted({ error: eventerror }, true));
                    const error = new Error('Unable to fetch Occurrences for registry ' +
                                            `: ${registryId}` +
                                            `Cause: ${eventerror.message || eventerror}`);
                    error.error = eventerror;
                  }),
        ]);
      }, eventerror => {
        dispatch(fetchEduRecCompleted({ error: eventerror }, true));
        const error = new Error(`Unable to fetch Educational Record no. : ${registryId}` +
                                `Cause: ${eventerror.message || eventerror}`);
        error.error = eventerror;
        throw error;
      });
  };
}

// ACTIONS FOR TRASVERSAL
export function creatingTrasRec(idCopertura) {
  return {
    type: TRASVERSAL.CREATE,
    payload: idCopertura,
  };
}

export function creatingTrasRecCompleted(registry, error = false) {
  console.log('registro creato: ', registry);
  const arrPayload = [];
  arrPayload.push(registry);
  return {
    type: TRASVERSAL.CREATE_COMPLETED,
    payload: arrPayload,
    error,
  };
}

export function createTrasRec(acYear) {
  return (dispatch) => {
    dispatch(creatingTrasRec(acYear));
    return createTrasversalRecWS(acYear)
      .then(response =>
            dispatch(creatingTrasRecCompleted(response))
            , eventerror => {
              console.log('DEBUG 20170915:', eventerror);
              dispatch(creatingTrasRecCompleted({ error: eventerror }, true));
              return Promise.reject(eventerror);
            });
  };
}

export function closingTrasRec(registryId) {
  return {
    type: TRASVERSAL.CLOSE,
    payload: registryId,
  };
}

export function closedTrasRec(registry) {
  return {
    type: TRASVERSAL.CLOSE_COMPLETED,
    payload: registry,
  };
}

export function setTrasRecClosed(registryId) {
  return (dispatch) => {
    dispatch(closingEduRec(registryId));
    return closeTrasversalRecWS(registryId)
      .then(response =>
            dispatch(closedTrasRec(response)));
  };
}

export function openingTrasRec(registryId) {
  return {
    type: TRASVERSAL.OPEN,
    payload: registryId,
  };
}

export function openedTrasRec(registry) {
  return {
    type: TRASVERSAL.OPEN_COMPLETED,
    payload: registry,
  };
}

export function setTrasRecOpened(registryId) {
  return (dispatch) => {
    dispatch(openingEduRec(registryId));
    return openTrasversalRecWS(registryId)
      .then(response =>
            dispatch(openedTrasRec(response)));
  };
}

export function deletingTrasRec(registryId) {
  return {
    type: TRASVERSAL.DELETE,
    payload: registryId,
  };
}

export function deletedTrasRec(registryId) {
  return {
    type: TRASVERSAL.DELETE_COMPLETED,
    payload: registryId,
  };
}

export function setTrasRecDeleted(registryId) {
  return (dispatch) => {
    dispatch(deletingEduRec(registryId));
    return deleteTrasversalRecWS(registryId)
      .then(
        dispatch(deletedEduRec(registryId))
      );
  };
}

export function updatingTrasversalNotes(registryId) {
  return {
    type: TRASVERSAL.UPDATING_NOTES,
    payload: registryId,
  };
}

export function updateTrasversalNotesCompleted(registry, error = false) {
  return {
    type: TRASVERSAL.UPDATING_NOTES_COMPLETED,
    payload: registry,
    error,
  };
}

export function updateTrasversalNotes(registryId, notes, descResearch) {
  return (dispatch) => {
    dispatch(updatingTrasversalNotes(registryId));
    return updateTrasversalNotesWS(registryId, notes, descResearch)
      .then(response =>
            dispatch(updateTrasversalNotesCompleted(response))
            , eventerror => {
              dispatch(updateTrasversalNotesCompleted({ error: eventerror }, true));
              const error = new Error('Unable to update Notes' +
                                      `for Trasversal no. : ${registryId}` +
                                      `Cause: ${eventerror.message || eventerror}`);
              error.error = eventerror;
            });
  };
}

export function fetchTrasFormeDidCompleted(formeDid, error = false) {
  return {
    type: TRASVERSAL.FETCH_FORMEDID,
    payload: formeDid,
    error,
  };
}

export function fetchTrasFormeDid() {
  return (dispatch) =>
    retrieveTrasFormeDidWS()
    .then(response =>
          dispatch(fetchTrasFormeDidCompleted(response)));
}

// ACTIONS FOR TRASVERSAL OCCURRENCES
export function fetchTrasActivitiesOngoing(registryId) {
  return {
    type: TRAS_OCCURRENCES.FETCH,
    payload: registryId,
  };
}

export function fetchTrasActivitiesCompleted(activities, error = false) {
  return {
    type: TRAS_OCCURRENCES.FETCH_COMPLETED,
    payload: activities,
    error,
  };
}

export function fetchTrasActivities(registryId) {
  return (dispatch) => {
    dispatch(fetchTrasActivitiesOngoing(registryId));
    return retrieveTrasOccurrencesWS(registryId)
      .then(response =>
            dispatch(fetchTrasActivitiesCompleted(response))
            , eventerror => {
              dispatch(fetchTrasActivitiesCompleted({ error: eventerror }, true));
              const error = new Error('Unable to fetch Occurrences for trasversal registry ' +
                                      `: ${registryId}` +
                                      `Cause: ${eventerror.message || eventerror}`);
              error.error = eventerror;
            });
  };
}

export function insertingTrasversalActivitiesOngoing(registryId) {
  return {
    type: TRAS_OCCURRENCES.CREATE,
    payload: registryId,
  };
}

export function insertingTrasversalActivitiesCompleted(trasActivities, error = false) {
  return {
    type: TRAS_OCCURRENCES.CREATE_COMPLETED,
    payload: trasActivities,
    error,
  };
}

export function insertTrasversalActivities(registryId, trasActivities) {
  return (dispatch) => {
    dispatch(insertingTrasversalActivitiesOngoing(registryId));
    return insertTrasversalActivitiesWS(registryId, trasActivities)
      .then(response =>
            dispatch(insertingTrasversalActivitiesCompleted(response))
            , eventerror => {
              dispatch(insertingTrasversalActivitiesCompleted({ error: eventerror }, true));
              const error = new Error('Unable to insert trasversal activities');
              error.error = eventerror;
              throw error;
            });
  };
}

export function removingTrasversalActivities(registryId) {
  return {
    type: TRAS_OCCURRENCES.DELETE,
    payload: registryId,
  };
}

export function removingTrasversalActivitiesCompleted(occurrences, error = false) {
  return {
    type: TRAS_OCCURRENCES.DELETE_COMPLETED,
    payload: occurrences,
    error,
  };
}

export function removeTrasversalActivities(registryId, occurrences) {
  return (dispatch) => {
    dispatch(removingTrasversalActivities(registryId));
    return removeTrasversalActivitiesWS(registryId, occurrences)
      .then(response =>
            dispatch(removingTrasversalActivitiesCompleted(response))
            , eventerror => Promise.reject(eventerror)
           );
  };
}

export function updatingTrasversalActivities(registryId) {
  return {
    type: TRAS_OCCURRENCES.UPDATE,
    payload: registryId,
  };
}

export function updateTrasversalActivitiesCompleted(occurrences, error = false) {
  return {
    type: TRAS_OCCURRENCES.UPDATE_COMPLETED,
    payload: occurrences,
    error,
  };
}

export function updateTrasversalActivities(registryId, occurrences) {
  return (dispatch) => {
    dispatch(updatingTrasversalActivities(registryId));
    return updateTrasversalActivitiesWS(registryId, occurrences)
      .then(response =>
            dispatch(updateTrasversalActivitiesCompleted(response))
            , eventerror => {
              dispatch(updateTrasversalActivitiesCompleted({ error: eventerror }, true));
              const error = new Error(`Unable to update Trasversal Record no. : ${registryId}` +
                                      `Cause: ${eventerror.message || eventerror}`);
              error.error = eventerror;
            });
  };
}

// ACTIONS FOR USER
export function fetchUserOngoing() {
  return {
    type: USER.FETCH,
    payload: {},
  };
}

export function fetchUserCompleted(user, error = false) {
  return {
    type: USER.FETCH_COMPLETED,
    payload: user,
    error,
  };
}

export function fetchUser() {
  return (dispatch) => {
    dispatch(fetchUserOngoing());
    return retrieveUser()
      .then(response =>
            dispatch(fetchUserCompleted(response))
            , eventerror => {
              dispatch(fetchUserCompleted({ error: eventerror }, true));
              const error = new Error('Unable to retrieve user infos');
              error.error = eventerror;
              return Promise.reject(error);
            });
  };
}

export function changeUser(newCF) {
  return {
    type: USER.CHANGE,
    payload: newCF,
  };
}

export function embodyUser(newCF, acYear) {
  return (dispatch) => {
    console.log('che anno ho:', acYear);
    dispatch(changeUser(newCF));
    dispatch(fetchEduRecs(acYear));
    dispatch(fetchCriticalEduRecs(acYear));
  };
}
